type EngagementMetricsKpiTileProps = {
  label: string;
  value: string | number;
  caption?: string;
  dotColor: string;
};

/**
 * KPI card recipe from engagement_metrics_design.md §3: label + status dot on
 * the top row, a large tabular value, and a muted caption underneath.
 */
export const EngagementMetricsKpiTile = ({
  label,
  value,
  caption,
  dotColor,
}: EngagementMetricsKpiTileProps) => {
  return (
    <div
      className="bg-white rounded-xl border p-4"
      style={{ borderColor: '#e7e2d8', boxShadow: '0 1px 2px rgba(20,40,30,.05)' }}
    >
      <div className="flex items-center justify-between">
        <span className="text-[12px] font-semibold" style={{ color: '#7f8a83' }}>
          {label}
        </span>
        <span
          className="inline-block h-[9px] w-[9px] rounded-full"
          style={{ backgroundColor: dotColor }}
          aria-hidden="true"
        />
      </div>
      <div
        className="mt-2 font-extrabold tabular-nums"
        style={{ fontSize: 28, letterSpacing: '-0.5px', color: '#1b2a23' }}
      >
        {value}
      </div>
      {caption && (
        <div className="mt-1 text-[11.5px]" style={{ color: '#7f8a83' }}>
          {caption}
        </div>
      )}
    </div>
  );
};
